var _style, _linearGradient, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyResults(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 300 208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st0{opacity:5.000000e-02;fill:url(#SVGID_1_);enable-background:new ;} .st1{fill:#EAEAE9;} .st2{opacity:0.42;fill:#C1C1C1;enable-background:new ;} .st3{fill:#C1C1C1;} .st4{fill:#F4F4F4;} .st5{opacity:0.15;fill:#C1C1C1;enable-background:new ;}\n  ")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n    Search_web\n  ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 32.846,
    x2: 147.417,
    y1: 48.251,
    y2: 11.017,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 210)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9 180.2l89.9 22.5 1.7-1.7-38.9-18.1H152c1.4-.8 1.6-2.7 0-2.7H26.9z",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.4 181.8l-27.5-89.1 3.1-1 27.5 89.1c.3.9-.2 1.8-1.1 2-.9.3-1.8-.1-2-1z",
    className: "st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.1 92.3l-1.2.4 27.5 89.1c.1.3.3.6.5.8.5-.4.7-1.1.5-1.8l-27.3-88.5z",
    className: "st2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.9 182l-.1-.5 3.1-.9.1.5c.3.9-.2 1.8-1.1 2-.9.2-1.8-.3-2-1.1z",
    className: "st3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.6 94.8l4.9-1.5 14.2 45.9c.2.6-.2 1.3-.8 1.5l-2.6.8c-.6.2-1.3-.2-1.5-.8l-14.2-45.9z",
    className: "st1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.6 94.8l14.2 46c.2.6.9 1 1.5.8l1.5-.5L125.2 94l-2.6.8z",
    className: "st2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8 180l27-89.5 3.1.9-27 89.5c-.3.9-1.2 1.4-2 1.1-.9-.2-1.4-1.1-1.1-2z",
    className: "st1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M107.8 92.3l1.2.4-27.5 89.1c-.1.3-.3.6-.5.8-.5-.4-.7-1.1-.5-1.8l27.3-88.5z",
    className: "st2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4 180.8l.2-.5 3.1 1-.2.5c-.3.9-1.2 1.3-2 1.1-.9-.3-1.4-1.2-1.1-2.1z",
    className: "st3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7 141.5l-2.6-.8c-.6-.2-1-.9-.8-1.5l14.2-45.9 4.9 1.5-14.2 45.9c-.2.7-.9 1-1.5.8z",
    className: "st1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.3 94.8l-14.2 46c-.2.6-.9 1-1.5.8l-1.5-.5L106.7 94l2.6.8z",
    className: "st2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.1 96.6h3.3V201c0 .9-.7 1.7-1.7 1.7-.9 0-1.7-.7-1.7-1.7V96.6h.1z",
    className: "st1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M115.1 127.1h3.3v19.7c0 .4-.3.7-.7.7h-1.9c-.4 0-.7-.3-.7-.7v-19.7z",
    className: "st2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M115 199.3h3.3v1.7c0 .9-.7 1.7-1.7 1.7-.9 0-1.7-.7-1.7-1.7v-1.7h.1z",
    className: "st3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M113.7 96.6h6.1V143c0 1.6-1.3 2.8-2.8 2.8h-.4c-1.6 0-2.8-1.3-2.8-2.8l-.1-46.4z",
    className: "st1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M113.1 77.7h5.7v9.8h-5.7z",
    className: "st2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1 89.8l27.6-10.2c.5-.2 1.1.1 1.2.6l2.3 6.2c.2.5-.1 1.1-.6 1.2L57.1 97.8c-.5.2-1.1-.1-1.2-.6L53.5 91c-.2-.5.1-1 .6-1.2z",
    className: "st4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5 87.2L75.3 91l.7-9.3 6.6-2.5z",
    className: "st2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1 88.7l1.2-.5c.7-.2 1.4.2 1.7.8l2.7 7.4c.2.7-.1 1.4-.8 1.7l-1.2.5c-.7.2-1.4-.1-1.7-.8l-2.7-7.4c-.3-.7.1-1.4.8-1.7z",
    className: "st3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2 77.6l28.1-10.4 4.3 11.7-28 10.4c-.7.2-1.4-.1-1.7-.8l-3.5-9.3c-.2-.6.2-1.4.8-1.6z",
    className: "st1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M112.7 79.3l-10.5 3.9-.4-13.2 6.6-2.4z",
    className: "st2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2 84.1l1.7 4.5c.2.7 1 1 1.7.8L113.8 79l-2.1-5.7-29.5 10.8z",
    className: "st5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 115.9,
    cy: 88.7,
    r: 3.7,
    className: "st3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 90.4h22.3c.9 0 1.6.7 1.6 1.5v2.3h-25.5V92c0-.9.7-1.6 1.6-1.6z",
    className: "st1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M103.3 93.4h25.5v.8h-25.5z",
    className: "st2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M100.3 94.2h31.6c.9 0 1.6.7 1.6 1.6v1.5c0 .9-.7 1.6-1.6 1.6h-31.6c-.9 0-1.6-.7-1.6-1.6v-1.5c-.1-.8.7-1.6 1.6-1.6z",
    className: "st3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2 92.4l24-8.3 1.5 3.8-24 8.6z",
    className: "st5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M108.7 64.1l35-13 6.2 16.6c.2.5-.1 1.1-.6 1.3l-34.1 12.6c-1.1.4-2.3-.1-2.6-1.2l-5.1-13.7c-.4-1 .1-2.2 1.2-2.6z",
    className: "st4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M151.9 68.1l-18.4 6.8 1.9-20.6 10-3.7z",
    className: "st2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M146.9 59.8L110 73.5l2.6 7c.4 1.1 1.6 1.6 2.6 1.2l34.1-12.6c.5-.2.8-.7.6-1.2l-3-8.1z",
    className: "st5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M168.2 41.2l7.1 19.1c4.4-4.3 4.5-11.3.2-15.8-1.9-1.9-4.5-3.1-7.3-3.3z",
    className: "st1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M166.1 40.4l3.4-1.2c.5-.2 1.1.1 1.3.6l7.4 20.1c.2.5-.1 1.1-.6 1.3l-3.4 1.2-8.1-22z",
    className: "st3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M143.4 48.6l23.2-8.6 8.2 22-23.2 8.6c-1.2.5-2.6-.2-3-1.4l-6.5-17.5c-.5-1.3.1-2.6 1.3-3.1z",
    className: "st1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M144.8 60.6l3.3 8.9c.5 1.2 1.8 1.8 3 1.4l23.1-8.5-4.1-11.2-25.3 9.4z",
    className: "st5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M197.9 2.9l2.9 1-2.9 1-1 2.9-1-2.9-2.8-1 2.8-1 1-2.9zM205.7 98l2.9 1-2.9 1-1 2.9-1-2.9-2.9-1 2.9-1 1-2.9zM267.2 3.4l1.5.5-1.5.5-.5 1.4-.5-1.4-1.4-.5 1.4-.5.5-1.5zM227.8 35.4l1.5.5-1.5.5-.5 1.4-.5-1.4-1.4-.5 1.4-.5.5-1.5zM95.2 28.2l1.4.5-1.4.5-.5 1.4-.5-1.4-1.4-.5 1.4-.5.5-1.4zM18.6 15.1l1.5.5-1.5.5-.5 1.5-.5-1.5-1.4-.5 1.4-.5.5-1.4z",
    className: "st3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyResults);
export default __webpack_public_path__ + "static/media/emptyResults.6a902f7d750da6a0ed54293d0bb5eb39.svg";
export { ForwardRef as ReactComponent };